"use strict";

var _typeof3 = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.each = each;
exports.normalizeValueDeclaration = normalizeValueDeclaration;
exports.checkValue = checkValue;
exports.checkParams = checkParams;
exports.getAllDescriptionTable = getAllDescriptionTable;
exports.checkParamsCorrect = checkParamsCorrect;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _env = _interopRequireWildcard(require("./env"));

var _log = require("./log");

var _noticeError = require("./noticeError");

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * @File         : 描述表校验相关函数-部分来自js-native（https://github.com/ecomfe/js-native/blob/master/index.js）
 * @Author       : gaojiajun01
 * @Date         : 2022-07-29 14:42:02
 * @LastEditors  : gaojiajun01
 * @LastEditTime : 2022-09-04 02:26:21
*/
;
/**
 * 对数组进行遍历
 * @param {Array} array 要遍历的数组
 * @param {Function} fn 遍历函数
 */

function each(array, fn) {
  var len = array && array.length || 0;

  for (var i = 0, l = len; i < l; i++) {
    if (fn(array[i], i) === false) {
      break;
    }
  }
}
/**
 * 对值声明进行标准化处理
 * @param {Object|string} declaration 值声明
 * @return {Object}
 */


function normalizeValueDeclaration(declaration) {
  if (typeof declaration === 'string') {
    var realDeclaration = {
      isRequired: true
    };

    if (/=$/.test(declaration)) {
      realDeclaration.isRequired = false;
      declaration = (0, _slice.default)(declaration).call(declaration, 0, declaration.length - 1);
    }

    if (/\[\]$/.test(declaration)) {
      realDeclaration.arrayOf = (0, _slice.default)(declaration).call(declaration, 0, declaration.length - 2);
    } else if ((0, _indexOf.default)(declaration).call(declaration, '|') > 0) {
      realDeclaration.oneOfType = declaration.split('|');
    } else {
      realDeclaration.type = declaration;
    }

    return realDeclaration;
  }

  return declaration;
}
/**
 * 对参数值进行检查
 *
 * @inner
 * @param {*} value 值
 * @param {Object} declaration 值声明
 * @return {number}
 */


function checkValue(value, declaration) {
  declaration = normalizeValueDeclaration(declaration);

  if (value == null) {
    return declaration.isRequired && declaration.type !== '*' ? 1 : 0;
  }

  var valid = false;

  switch ((0, _typeof2.default)(declaration.type)) {
    case 'string':
      switch (declaration.type) {
        case 'string':
        case 'boolean':
        case 'number':
        case 'function':
        case 'object':
          valid = (0, _typeof2.default)(value) === declaration.type;
          break;

        case 'Object':
          valid = (0, _typeof2.default)(value) === 'object';
          break;

        case 'Array':
          valid = value instanceof Array;
          break;

        case '*':
          valid = true;
          break;
      }

      if (!valid) {
        return 2;
      }

      break;

    case 'object':
      if (value && (0, _typeof2.default)(value) === 'object') {
        valid = true;

        for (var key in declaration.type) {
          valid = !checkValue(value[key], declaration.type[key]);

          if (!valid) {
            break;
          }
        }
      }

      if (!valid) {
        return 2;
      }

      break;

    default:
      if (declaration.oneOf) {
        each(declaration.oneOf, function (expectValue) {
          valid = expectValue === value;
          return !valid;
        });

        if (!valid) {
          return 3;
        }
      } else if (declaration.oneOfType) {
        each(declaration.oneOfType, function (expectType) {
          valid = !checkValue(value, expectType);
          return !valid;
        });

        if (!valid) {
          return 4;
        }
      } else if (declaration.arrayOf) {
        if (value instanceof Array) {
          valid = true;
          each(value, function (item) {
            return valid = !checkValue(item, declaration.arrayOf);
          });

          if (!valid) {
            return 5;
          }
        } else {
          return 2;
        }
      }

  }

  return 0;
}

var descriptionTable;
/**
 * 获取全部描述表
 * @param {Array} args 调用参数
 * @param {Array} declarations 参数声明列表
 */

function getAllDescriptionTable() {
  if (!descriptionTable) {
    var _window$__bmls__;

    var getNaTableFn = (_window$__bmls__ = window.__bmls__) === null || _window$__bmls__ === void 0 ? void 0 : _window$__bmls__.getAPIs;

    if (!getNaTableFn || typeof getNaTableFn !== 'function') {
      (0, _log.send_log_table_exception_event)({
        msg: '描述表函数不存在',
        exceptionType: 0
      });
      throw new Error('描述表函数不存在');
    }

    var returnValue = window.__bmls__.getAPIs();

    var jsonObject;

    try {
      jsonObject = JSON.parse(returnValue);
    } catch (_unused) {
      (0, _log.send_log_table_exception_event)({
        msg: '描述表json解析错误',
        exceptionType: 1,
        table: returnValue
      });
      throw new Error('描述表json解析错误');
    }

    var _jsonObject = jsonObject,
        descriptions = _jsonObject.descriptions;
    var table = Array.isArray(descriptions) ? descriptions : [];

    if (table.length === 0) {
      (0, _log.send_log_table_exception_event)({
        msg: '描述表长度为0',
        exceptionType: 0
      }); // noticeError('描述表长度为0');

      throw new Error('描述表长度为0');
    }

    descriptionTable = {};
    (0, _forEach.default)(table).call(table, function (item) {
      var _item$name$split = item.name.split('.'),
          _item$name$split2 = (0, _slicedToArray2.default)(_item$name$split, 2),
          subModule = _item$name$split2[0],
          action = _item$name$split2[1];

      if (!descriptionTable[subModule]) {
        descriptionTable[subModule] = {};
      }

      descriptionTable[subModule][action] = {
        subModule: subModule,
        action: action,
        name: item.name,
        args: item.args // returnValues: item.returnValues

      };
    });
  }

  return descriptionTable;
}
/**
 * 参数检查，错误直接抛出异常
 * @param {Array} params 调用参数
 * @param {Array} declarations 参数声明列表
 */


function checkParams(params, declarations, naAbilityName) {
  each(declarations, function (declaration, i) {
    var errorMsg;
    var value = normalizeValueDeclaration(declaration.value);

    switch (checkValue(params[i], value)) {
      case 1:
        errorMsg = ' is required.';
        break;

      case 2:
        errorMsg = ' type error. must be ' + (0, _stringify.default)(value.type || 'Array');
        break;

      case 3:
        errorMsg = ' type error, must be oneOf ' + (0, _stringify.default)(value.oneOf);
        break;

      case 4:
        errorMsg = ' type error, must be oneOfType ' + (0, _stringify.default)(value.oneOfType);
        break;

      case 5:
        errorMsg = ' type error, must be arrayOf ' + (0, _stringify.default)(value.arrayOf);
        break;
    }

    if (errorMsg) {
      var _context, _context2;

      var errorInfo = '[Argument Error]' + declaration.name + errorMsg;
      (0, _log.send_log_table_exception_event)({
        msg: '类型校验错误',
        exceptionType: 1,
        detail: (0, _concat.default)(_context = (0, _concat.default)(_context2 = "\u7AEF\u80FD\u529B".concat(naAbilityName, "\u7684")).call(_context2, declaration.name, "\u53C2\u6570\u7C7B\u578B\u6821\u9A8C\u5F02\u5E38\uFF0C\u8BE6\u7EC6\u4FE1\u606F\uFF1A")).call(_context, errorInfo),
        schemeName: naAbilityName
      });
      (0, _noticeError.noticeError)(errorInfo);
    }
  });
}
/**
 * 获取当前调用端能力的描述表并检查参数是否正确
 * @param {Object} parsedScheme
 */


function checkParamsCorrect(parsedScheme) {
  try {
    if ((0, _env.versionCompare)(_env.default.sdkVersion, '6.4.0') < 0) {
      return {
        succeess: true,
        useParams: parsedScheme.params
      };
    }

    if (!descriptionTable) {
      getAllDescriptionTable();
    } // console.log(descriptionTable, 'descriptionTable');


    var subModuleName = parsedScheme.subModuleName,
        actionName = parsedScheme.actionName,
        _parsedScheme$params = parsedScheme.params,
        params = _parsedScheme$params === void 0 ? {} : _parsedScheme$params;
    var currentSchemeDescriptionTable = descriptionTable[subModuleName] ? descriptionTable[subModuleName][actionName] || {} : {};

    if ((0, _keys.default)(currentSchemeDescriptionTable).length === 0) {
      (0, _log.send_log_table_exception_event)({
        msg: '当前环境不存在该端能力',
        exceptionType: 1,
        schemeName: subModuleName + '.' + actionName
      });
      (0, _noticeError.noticeError)("\u5F53\u524D\u73AF\u5883\u4E0D\u5B58\u5728".concat(subModuleName + '.' + actionName, "\u7AEF\u80FD\u529B"));
      return {
        succeess: false
      };
    }

    var currentSchemeDescriptionTableParams = currentSchemeDescriptionTable.args || []; // 手动追加一个timeout字段，并为可选参数，表示超时时间

    currentSchemeDescriptionTableParams.push({
      name: 'timeout',
      value: 'number='
    }); // 根据描述表里需要的参数和传入的参数，按描述表返回的参数顺序，生成一个数组，数组值是传入参数的值,如果没传该参数值为undefined
    // eg: currentSchemeDescriptionTableParams = [{name: 'a', "value": "string="}, {name: 'b', "value": "string="}]
    // eg: params = {a:'1',c:2}
    // eg: actualSchemeParams = ['1', undefined]

    var actualSchemeParams = (0, _map.default)(currentSchemeDescriptionTableParams).call(currentSchemeDescriptionTableParams, function (paramObj) {
      return params[paramObj.name];
    }); // 先校验参数类型

    checkParams(actualSchemeParams, currentSchemeDescriptionTableParams, currentSchemeDescriptionTable.name); // 根据描述表过滤后的参数对象

    var filterParamsObj = (0, _reduce.default)(currentSchemeDescriptionTableParams).call(currentSchemeDescriptionTableParams, function (acc, paramObj) {
      if (params.hasOwnProperty(paramObj.name)) {
        acc[paramObj.name] = params[paramObj.name];
      }

      return acc;
    }, {});

    if ((0, _keys.default)(filterParamsObj).length !== (0, _keys.default)(params).length) {
      var _context3, _context4;

      var errorInfo = (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "\u7AEF\u80FD\u529B".concat(currentSchemeDescriptionTable.name, "\u90E8\u5206\u53C2\u6570\u88AB\u8FC7\u6EE4\uFF0C\u8BF7\u68C0\u67E5\u3002\u539F\u53C2\u6570")).call(_context4, (0, _stringify.default)(params), "\uFF0C\u8FC7\u6EE4\u540E\u53C2\u6570")).call(_context3, (0, _stringify.default)(filterParamsObj));
      (0, _log.send_log_table_exception_event)({
        msg: '部分参数被过滤',
        exceptionType: 1,
        detail: errorInfo,
        schemeName: currentSchemeDescriptionTable.name
      });
      (0, _noticeError.noticeError)(errorInfo);
    }

    return {
      succeess: true,
      useParams: filterParamsObj
    };
  } catch (e) {
    var _errorInfo = "".concat(e.toString ? e.toString() : e + '');

    (0, _log.send_log_table_exception_event)({
      msg: 'catch捕获',
      exceptionType: 0,
      detail: _errorInfo,
      schemeName: parsedScheme.subModuleName + '.' + parsedScheme.actionName
    });
    console.error('catch捕获', e);
    return {
      succeess: false
    };
  }
}